// filepath: /home/duongnh/Desktop/duongnh/github/review-truong/client/src/components/RatingStars.jsx
import React from "react";

/**
 * Component hiển thị đánh giá bằng sao
 * @param {Object} props
 * @param {number} props.rating - Điểm đánh giá (1-5)
 * @param {string} [props.className] - Class CSS bổ sung
 * @param {boolean} [props.integerOnly=false] - Chỉ hiển thị số nguyên (không có nửa sao)
 * @returns {JSX.Element}
 */
export default function RatingStars({
  rating,
  className = "",
  integerOnly = false,
}) {
  // Đảm bảo rating là số hợp lệ từ 0-5
  const validRating = Math.max(
    0,
    Math.min(5, typeof rating === "number" && !isNaN(rating) ? rating : 0)
  );

  // Luôn hiển thị 5 sao
  const totalStars = 5;

  let filledStars;
  if (integerOnly) {
    // Chế độ số nguyên: làm tròn rating
    filledStars = Math.round(validRating);
  } else {
    // Chế độ thập phân: cho phép nửa sao
    filledStars = validRating;
  }

  return (
    <div className={`rating-stars ${className}`}>
      {Array.from({ length: totalStars }).map((_, index) => {
        const starNumber = index + 1;
        let starClass = "star";

        if (integerOnly) {
          // Chế độ số nguyên: sao vàng hoặc trắng
          starClass +=
            starNumber <= filledStars ? " star--filled" : " star--empty";
        } else {
          // Chế độ thập phân: có thể có nửa sao
          if (starNumber <= Math.floor(filledStars)) {
            starClass += " star--filled";
          } else if (starNumber === Math.ceil(filledStars)) {
            starClass += " star--half";
          } else {
            starClass += " star--empty";
          }
        }

        return (
          <span key={index} className={starClass}>
            {/* Sao được hiển thị qua CSS content */}
          </span>
        );
      })}
    </div>
  );
}
